<header class="modal-header">
  <h2 class="modal-title">Motivo da Recusa</h2>
  <button class="close-btn" (click)="activeModal.close(true)" aria-label="Fechar">
    &times;
  </button>
</header>
<main class="modal-body">
  <div class="modal-content">
    <p class="reason-text">{{ reason }}</p>
  </div>
</main>
